module.exports = __webpack_public_path__ + "img/antes_despues_29.50dba744.png";